import { useGetMeQuery } from 'store/services/user/meApi';

export const useIsElite = (skip: boolean = false) => {
  const { data: user, isLoading, isFetching } = useGetMeQuery(undefined, { skip });

  // UI display only - actual subscription validation is enforced server-side
  const isElite = user?.isElite || false;
  const eliteSince = user?.eliteSince || null;
  const isEliteStatusResolved = !isLoading && !isFetching && user !== undefined;

  return { isElite, eliteSince, user, isLoading, isEliteStatusResolved };
};
